import { useId } from 'react';

export type UseSvgId = {
  id: string;
  idUrl: string;
};

export function useSvgId(): UseSvgId {
  const id = useId();

  return {
    id,
    idUrl: `url(#${id})`,
  };
}
